// Generated types for FluidFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FluidFlowReadAPI extends SysMLBehaviorReadAPI {
  /** Flow rate */
  flow_rate?: number | null;
  /** Pressure rating */
  pressure?: number | null;
  /** Temperature */
  temperature?: number | null;
}

export interface FluidFlowWriteAPI extends SysMLBehaviorWriteAPI {
  /** Flow rate */
  flow_rate?: number | null;
  /** Pressure rating */
  pressure?: number | null;
  /** Temperature */
  temperature?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FluidFlowReadAPISchema: z.ZodType<FluidFlowReadAPI> = SysMLBehaviorReadAPISchemaObject.extend({
  flow_rate: z.number().nullable().optional(),
  pressure: z.number().nullable().optional(),
  temperature: z.number().nullable().optional(),
}).passthrough();

export const FluidFlowWriteAPISchema: z.ZodType<FluidFlowWriteAPI> = SysMLBehaviorWriteAPISchemaObject.extend({
  flow_rate: z.number().nullable().optional(),
  pressure: z.number().nullable().optional(),
  temperature: z.number().nullable().optional(),
}).passthrough();
